import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import './Options.css';
import typeTranslations from '../../assets/creator/typeTranslations';
import { getTranslation } from '../../assets/creator/translations';
import { formatString } from '../../utils/string/string';
import InputInteger from '../InputInteger/InputInteger';
import RecommendedTypeSelector from '../Page/ElementSelector/TypeElementsAndOptions/RecommendedTypeSelector';
import PromotionalBannerTypeSelector from '../Page/ElementSelector/TypeElementsAndOptions/PromotionalBannerTypeSelector';
// import { changeSettingsValueInAllThemes } from '../../assets/creator/themes';
import { changeTemplateSettings, getImportedTemplateSettings, getDefaultTemplateSettings } from '../../assets/creator/template';
import SimpleTypeSelector from '../Page/ElementSelector/TypeElementsAndOptions/SimpleTypeSelector';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

class Options extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: false,
            commodityAmount: 0,
            elementType: null,
            amtFieldName: null,
            recommendedType: null,
            promotionalBannerType: null,
            inquiries: getDefaultTemplateSettings('inquiries'),
            categoryOpenedClosed: getDefaultTemplateSettings('categoryOpenedClosed'),
            maxfilter: getDefaultTemplateSettings('maxfilter'),
            selectedViewName: getDefaultTemplateSettings('selectedViewName'),
            showAttributesOnProductsPage: getDefaultTemplateSettings('showAttributesOnProductsPage'),
            attributesQuantityOnQuickView: getDefaultTemplateSettings('attributesQuantityOnQuickView'),
            showAllAttributesOnQuickView: getDefaultTemplateSettings('showAllAttributesOnQuickView'),
            attributesQuantityOnListView: getDefaultTemplateSettings('attributesQuantityOnListView'),
            showAllAttributesOnListView: getDefaultTemplateSettings('showAllAttributesOnListView'),
            showShortDesc: getDefaultTemplateSettings('showShortDesc'),
            allowAddingToCartMultiVariantProductsOnProductsList: getDefaultTemplateSettings('allowAddingToCartMultiVariantProductsOnProductsList'),
            showUnitRateOnCartPage: getDefaultTemplateSettings('showUnitRateOnCartPage'),
            showPoints: getDefaultTemplateSettings('showPoints'),

            productListFilters__Manufacturer: getDefaultTemplateSettings('productListFilters__Manufacturer'),
            productListFilters__Brand: getDefaultTemplateSettings('productListFilters__Brand'),
            productListFilters__Availability: getDefaultTemplateSettings('productListFilters__Availability'),
            productListFilters__Rate: getDefaultTemplateSettings('productListFilters__Rate'),
            productListFilters__Photos: getDefaultTemplateSettings('productListFilters__Photos'),
            productListFilters__Attributes: getDefaultTemplateSettings('productListFilters__Attributes'),
            productListFilters__Flags: getDefaultTemplateSettings('productListFilters__Flags'),
            productListFilters__FilterOption: getDefaultTemplateSettings('filterOption'),
        };
        this.minAmount = 1;
        this.maxAmount = 50;
        this.attributeMinAmount = 0;
    }

    saveInitialSettings = () => {
        localStorage.setItem('tempSettings', JSON.stringify(this.state));

        this.setState({inquiries: getDefaultTemplateSettings('inquiries')});
        this.setState({categoryOpenedClosed: getDefaultTemplateSettings('categoryOpenedClosed')});
        this.setState({maxfilter: getDefaultTemplateSettings('maxfilter')});
        this.setState({selectedViewName: getDefaultTemplateSettings('selectedViewName')});
        this.setState({showAttributesOnProductsPage: getDefaultTemplateSettings('showAttributesOnProductsPage')});
        this.setState({attributesQuantityOnQuickView: getDefaultTemplateSettings('attributesQuantityOnQuickView')});
        this.setState({showAllAttributesOnQuickView: getDefaultTemplateSettings('showAllAttributesOnQuickView')});
        this.setState({attributesQuantityOnListView: getDefaultTemplateSettings('attributesQuantityOnListView')});
        this.setState({showAllAttributesOnListView: getDefaultTemplateSettings('showAllAttributesOnListView')});
        this.setState({showShortDesc: getDefaultTemplateSettings('showShortDesc')});
        this.setState({allowAddingToCartMultiVariantProductsOnProductsList: getDefaultTemplateSettings('allowAddingToCartMultiVariantProductsOnProductsList')});
        this.setState({showUnitRateOnCartPage: getDefaultTemplateSettings('showUnitRateOnCartPage')});
        this.setState({showPoints: getDefaultTemplateSettings('showPoints')});

        this.setState({productListFilters__Manufacturer: getDefaultTemplateSettings('productListFilters__Manufacturer')});
        this.setState({productListFilters__Brand: getDefaultTemplateSettings('productListFilters__Brand')});
        this.setState({productListFilters__Availability: getDefaultTemplateSettings('productListFilters__Availability')});
        this.setState({productListFilters__Rate: getDefaultTemplateSettings('productListFilters__Rate')});
        this.setState({productListFilters__Photos: getDefaultTemplateSettings('productListFilters__Photos')});
        this.setState({productListFilters__Attributes: getDefaultTemplateSettings('productListFilters__Attributes')});
        this.setState({productListFilters__Flags: getDefaultTemplateSettings('productListFilters__Flags')});
        this.setState({productListFilters__FilterOption: getDefaultTemplateSettings('filterOption')});
    }

    restoreInitialSettings = () => {
        const defaultSettings = JSON.parse(localStorage.getItem('tempSettings'));   
        for (const [key, value] of Object.entries(defaultSettings)) {
            const k = `${key}`;
            const v = `${value}`;
            this.setState({[k]: v});
        }
        localStorage.removeItem('tempSettings');
    }

    handleSave = () => {
        if (this.state.error) {
            this.props.pushNotification("error", "Ntf_FailedToSaveSettings");
            return;
        }

        if(this.state.recommendedType === null) {
            this.props.updateChangesOption();
        }

        if(this.state.promotionalBannerType === null) {
            this.props.updateChangesOption();
        }

        let config = JSON.parse(this.props.elementInOptions.element.config);
        config[this.state.amtFieldName] = Number(this.state.commodityAmount);

        changeTemplateSettings('inquiries', this.state.inquiries);
        changeTemplateSettings('categoryOpenedClosed', this.state.categoryOpenedClosed);
        changeTemplateSettings('maxfilter', this.state.maxfilter);
        changeTemplateSettings('selectedViewName', this.state.selectedViewName);
        changeTemplateSettings('showAttributesOnProductsPage', this.state.showAttributesOnProductsPage);
        changeTemplateSettings('attributesQuantityOnQuickView', this.state.attributesQuantityOnQuickView);
        changeTemplateSettings('showAllAttributesOnQuickView', this.state.showAllAttributesOnQuickView);
        changeTemplateSettings('attributesQuantityOnListView', this.state.attributesQuantityOnListView);
        changeTemplateSettings('showAllAttributesOnListView', this.state.showAllAttributesOnListView);
        changeTemplateSettings('showShortDesc', this.state.showShortDesc);
        changeTemplateSettings('allowAddingToCartMultiVariantProductsOnProductsList', this.state.allowAddingToCartMultiVariantProductsOnProductsList);
        changeTemplateSettings('showUnitRateOnCartPage', this.state.showUnitRateOnCartPage);
        changeTemplateSettings('showPoints', this.state.showPoints);

        changeTemplateSettings('productListFilters__Manufacturer', this.state.productListFilters__Manufacturer);
        changeTemplateSettings('productListFilters__Brand', this.state.productListFilters__Brand);
        changeTemplateSettings('productListFilters__Availability', this.state.productListFilters__Availability);
        changeTemplateSettings('productListFilters__Rate', this.state.productListFilters__Rate);
        changeTemplateSettings('productListFilters__Photos', this.state.productListFilters__Photos);
        changeTemplateSettings('productListFilters__Attributes', this.state.productListFilters__Attributes);
        changeTemplateSettings('productListFilters__Flags', this.state.productListFilters__Flags);
        changeTemplateSettings('filterOption', this.state.productListFilters__FilterOption);


        if (this.state.recommendedType !== null) {
            config.Type = this.state.recommendedType;
            config = JSON.stringify(config);
            this.props.changeNameAndConfigForRecommended(this.props.elementInOptions, config, this.state.recommendedType, true);
        } else if (this.props.elementInOptions.element.type === 'promotionalBanner' && this.state.promotionalBannerType !== null) {
            config.Type = this.state.promotionalBannerType;
            config = JSON.stringify(config);
            this.props.changeNameAndConfigForRecommended(this.props.elementInOptions, config, this.state.promotionalBannerType, false);
        } else {
            config = JSON.stringify(config);
            this.props.changeConfig(this.props.elementInOptions.listName, this.props.elementInOptions.index, config, true);
        }

        // let templateSettings = JSON.parse(localStorage.getItem("onlineCreatorB2B-settings")); -- critical bug
        const templateSettings = require('../../assets/creator/templateSettings').default;
        this.props.updateTemplateSettings(templateSettings);
        this.props.pushNotification("success", "Ntf_SettingsSavedSuccessfully");
        this.props.closeOptions();
    }
    handleCommodityAmountChange = (input) => {
        if (input !== null) {
            this.setState({ commodityAmount: input, error: false });
        } else {
            this.setState({ error: true });
            setTimeout(function() { 
                this.setState({error: false})
            }.bind(this), 1000);
        } 
    }

    getAmtFieldNameByElemType = (type) => {
        switch (type) {
            case 'products-list':
                return "ItemsPerPage";
            case 'recommended':
            default: 
                return "TotalItems";
        }
    }
    putElementDataInState = () => {
        let initialState = {
            elementType: null,
            commodityAmount: null,
            amtFieldName: null,
            recommendedType: null,
            promotionalBannerType: null
        }
        if (this.props.elementInOptions !== null) {
            const elem = this.props.elementInOptions.element;
            const amtFieldName = this.getAmtFieldNameByElemType(elem.type);
            const config = JSON.parse(elem.config);

            initialState = {
                elementType: elem.type,
                commodityAmount: config[amtFieldName],
                amtFieldName: amtFieldName,
                recommendedType: config.Type || null,
                promotionalBannerType: config.Type || null
            }
        } 
        this.setState(initialState)
    }
    componentDidUpdate = (prevProps) => {
        //when options modal is opened, pull data from element
        //when options modal is closed, clears internal state
        if (prevProps.areOptionsOpen !== this.props.areOptionsOpen) {
            this.putElementDataInState();
        }
    }
    componentSettingsUpdateAfterImport = () => {
        // this.forceUpdate();
        this.setState({
            inquiries: getImportedTemplateSettings('inquiries'),
            categoryOpenedClosed: getImportedTemplateSettings('categoryOpenedClosed'),
            maxfilter: getImportedTemplateSettings('maxfilter'),
            selectedViewName: getImportedTemplateSettings('selectedViewName'),
            showAttributesOnProductsPage: getImportedTemplateSettings('showAttributesOnProductsPage'),
            attributesQuantityOnQuickView: getImportedTemplateSettings('attributesQuantityOnQuickView'),
            showAllAttributesOnQuickView: getImportedTemplateSettings('showAllAttributesOnQuickView'),
            attributesQuantityOnListView: getImportedTemplateSettings('attributesQuantityOnListView'),
            showAllAttributesOnListView: getImportedTemplateSettings('showAllAttributesOnListView'),
            showShortDesc: getImportedTemplateSettings('showShortDesc'),
            allowAddingToCartMultiVariantProductsOnProductsList: getImportedTemplateSettings('allowAddingToCartMultiVariantProductsOnProductsList'),
            showUnitRateOnCartPage: getImportedTemplateSettings('showUnitRateOnCartPage'),
            showPoints: getImportedTemplateSettings('showPoints'),

            productListFilters__Manufacturer: getImportedTemplateSettings('productListFilters__Manufacturer'),
            productListFilters__Brand: getImportedTemplateSettings('productListFilters__Brand'),
            productListFilters__Availability: getImportedTemplateSettings('productListFilters__Availability'),
            productListFilters__Rate: getImportedTemplateSettings('productListFilters__Rate'),
            productListFilters__Photos: getImportedTemplateSettings('productListFilters__Photos'),
            productListFilters__Attributes: getImportedTemplateSettings('productListFilters__Attributes'),
            productListFilters__Flags: getImportedTemplateSettings('productListFilters__Flags'),
            productListFilters__FilterOption: getImportedTemplateSettings('filterOption'),

        });
    }

    // Handlers

    onInquiriesChange = (e) => {
        this.setState({ inquiries: e.target.value });
    }

    onCategoryOpenedClosedChange = (e) => {
        this.setState({ categoryOpenedClosed: e.target.value });
    }

    onMaxfilterChange = (e) => {
        this.setState({ maxfilter: e.target.value });
    }

    onRecommendedTypeChange = (e) => {
        this.setState({ recommendedType: e.value })
        const arrows = document.querySelectorAll('.options .svgArrowRecommend');
        for (const arrow of arrows) {
            arrow.classList.toggle('hidden');
        }
    }

    onSelectedViewNameChange = (e) => {
        this.setState({ selectedViewName: e.target.value });
    }

    onShowAttributesOnProductsPageChange = (e) => {
        this.setState({ showAttributesOnProductsPage: e.target.value });
    }

    onAttributesQuantityOnDifferentViewChange = (value, quantityKeyName) => {
        if (value !== null) {
            this.setState({ 
                [quantityKeyName]: value,
                error: false 
            });
        } else {
            this.setState({ error: true });
        }
    }

    onShowAllAttributesOnDifferentViewChange = (showKeyName) => {
        if (this.state[showKeyName] === 'true') {
            this.setState({ [showKeyName]: null });
        } else {
            this.setState({ [showKeyName]: 'true' });
        }
    }

    onShowShortDescChange = (e) => {
        this.setState({ showShortDesc: e.target.value })
    }

    onAllowAddingToCartMultiVariantProductsOnProductsListChange = (e) => {
        this.setState({ allowAddingToCartMultiVariantProductsOnProductsList: e.target.value })
    }

    onShowUnitRateOnCartPageChange = (e) => {
        this.setState({ showUnitRateOnCartPage: e.target.value });
    }

    onProductListFiltersChange__Manufacturer = () => {
       this.setState((prevState) => {
           if (prevState.productListFilters__Manufacturer === 'Manufacturer_Yes') {
               return { productListFilters__Manufacturer: 'Manufacturer_No' };
           } else {
               return { productListFilters__Manufacturer: 'Manufacturer_Yes' };
           }
       });
    }

    onProductListFiltersChange__Brand = () => {
       this.setState((prevState) => {
           if (prevState.productListFilters__Brand === 'Brand_Yes') {
               return { productListFilters__Brand: 'Brand_No' };
           } else {
               return { productListFilters__Brand: 'Brand_Yes' };
           }
       });
    }

    onProductListFiltersChange__Availability = () => {
       this.setState((prevState) => {
           if (prevState.productListFilters__Availability === 'Availability_Yes') {
               return { productListFilters__Availability: 'Availability_No' };
           } else {
               return { productListFilters__Availability: 'Availability_Yes' };
           }
       });
    }

    onProductListFiltersChange__Rate = () => {
       this.setState((prevState) => {
           if (prevState.productListFilters__Rate === 'Rate_Yes') {
               return { productListFilters__Rate: 'Rate_No' };
           } else {
               return { productListFilters__Rate: 'Rate_Yes' };
           }
       });
    }

    onProductListFiltersChange__Photos = () => {
       this.setState((prevState) => {
           if (prevState.productListFilters__Photos === 'Photos_Yes') {
               return { productListFilters__Photos: 'Photos_No' };
           } else {
               return { productListFilters__Photos: 'Photos_Yes' };
           }
       });
    }

    onProductListFiltersChange__Attributes = () => {
       this.setState((prevState) => {
           if (prevState.productListFilters__Attributes === 'Attributes_Yes') {
               return { productListFilters__Attributes: 'Attributes_No' };
           } else {
               return { productListFilters__Attributes: 'Attributes_Yes' };
           }
       });
    }
    
    onProductListFiltersChange__Flags = () => {
       this.setState((prevState) => {
           if (prevState.productListFilters__Flags === 'Flags_Yes') {
               return { productListFilters__Flags: 'Flags_No' };
           } else {
               return { productListFilters__Flags: 'Flags_Yes' };
           }
       });
    }
    onProductListFilters__FilterOption = () => {
       this.setState((prevState) => {
           if (prevState.productListFilters__FilterOption === 'filterOption-yes') {
               return { productListFilters__FilterOption: 'filterOption-no' };
           } else {
               return { productListFilters__FilterOption: 'filterOption-yes' };
           }
       });
    }

    onPromoBannerTypeChange = (e) => {
        this.setState({ promotionalBannerType: e.value })
        const arrows = document.querySelectorAll('.options .svgArrowRecommend');
        for (const arrow of arrows) {
            arrow.classList.toggle('hidden');
        }
    }

    getPromotionalBannerTypeCurrent = function() {
        if (this.state.promotionalBannerType > 15) {
            return this.state.promotionalBannerType - 10;
        } else if (this.state.promotionalBannerType > 5 && this.state.promotionalBannerType <= 15) {
            return this.state.promotionalBannerType + 5;
        } else {
            return this.state.promotionalBannerType;
        }
    }

    getRecommendedTypeCurrent = function() {
        if (this.state.recommendedType > 15) {
            return this.state.recommendedType - 10;
        } else if (this.state.recommendedType > 5 && this.state.recommendedType <= 15) {
            return this.state.recommendedType + 5;
        } else {
            return this.state.recommendedType;
        }
    }

    // GET SELECTOR
    getAmountInput = (isProductsList = false) => (
        <div className="options__maxvalue-container">
            <p className="options__info">
                {getTranslation("InputMaxProductAmount")}
            </p>

            <InputInteger
                value={this.state.commodityAmount}
                onChange={this.handleCommodityAmountChange}
                minValue={this.minAmount}
                maxValue={this.maxAmount}
            />
             <p className="options__max-value">
                {(() => {
                    if (isProductsList) {
                        return formatString(getTranslation("ProductsListInputMaxValue"), this.maxAmount);
                    }
                    return getTranslation("InputMaxValue");
                })()}
            </p>
        </div>
    );

	getSimpleTypeSelector = (type, translation, typeHandler, typeSelector, inputType) => (
        <div> 
            <div>
                <SimpleTypeSelector
                    type={type}
                    translation={translation}
                    typeHandler={typeHandler}
                    typeSelector={typeSelector}
                    inputType={inputType}
                />
            </div>  
        </div>
    )

    getRecommendedTypeSelector = () => (
        <div className="options__rec-type-container">
            <RecommendedTypeSelector
                type="newsSection"
                recommendedTypeCurrent={this.getRecommendedTypeCurrent()}
                recommendedTypeChangeHandler={this.onRecommendedTypeChange}
                isFrom={"options"}
            />
        </div>
    );

    getPromotionalBannerTypeSelector = () => (
        <div className="options__rec-type-container">
            <PromotionalBannerTypeSelector
                type="promotionalBanner"
                promotionalBannerTypeCurrent={this.getPromotionalBannerTypeCurrent()}
                promotionalBannerTypeChangeHandler={this.onPromoBannerTypeChange}
                isFrom={"options"}
            />
        </div>
    );

    getAttributesOptionsOnViewSelector = (quantityType, quantityTypeSelector, showType, showTypeSelector, translation) => (
        <div className="options__maxvalue-container">
            <p className="options__info">
                {getTranslation(translation)}
            </p>

            <div className='options__inputs-wrapper'>
                <InputInteger
                    value={quantityType}
                    onChange={e => this.onAttributesQuantityOnDifferentViewChange(e, quantityTypeSelector)}
                    minValue={this.attributeMinAmount}
                    maxValue={this.maxAmount}
                />
                {this.getSimpleTypeSelector(showType, 'PrList_All', () => this.onShowAllAttributesOnDifferentViewChange(showTypeSelector), showTypeSelector, 'checkbox')}
            </div>
        </div>
    )

    // GET OPTIONS

    getOptionsForHeader = () => (
        <React.Fragment>
            {this.getSimpleTypeSelector(this.state.inquiries, 'Inquiries', this.onInquiriesChange, '')}
        </React.Fragment>
    )

    getOptionsForRecommended = () => (
        <React.Fragment>
            <div className="recommended-info">
                <FontAwesomeIcon className="recommended-info--icon" color="#fff" icon={faInfoCircle} />
                <span className="recommended-info--text">{getTranslation('RecommendedPopupInfo_Text')} <a target="__blank" href="https://pomoc.comarchesklep.pl/artykul/kreator-szablonu-szafir-b2b/">{getTranslation('RecommendedPopupInfo_Link')}</a>.</span>
            </div>
            {this.getAmountInput()}
            <p className="recommended-info--label options__info">{getTranslation('RecommendedPopupInfo_Label')}</p>
            {this.getRecommendedTypeSelector()}
        </React.Fragment>
    );

    getOptionsForPromotionalBanners = () => (
        <React.Fragment>
            <div className="recommended-modal-options__container">
                <div className="recommended-modal-options__center"> 
                    <div className="recommended-info">
                        <FontAwesomeIcon className="recommended-info--icon" color="#fff" icon={faInfoCircle} />
                        <span className="recommended-info--text">{getTranslation('RecommendedPopupInfo_Text')} <a target="__blank" href="https://pomoc.comarchesklep.pl/artykul/kreator-wygladu-szablonu-rubin/">{getTranslation('RecommendedPopupInfo_Link')}</a>.</span>
                    </div>
                    {this.getAmountInput()}
                    <p className="recommended-info--label options__info">{getTranslation('RecommendedPopupInfo_Label')}</p>
                    {this.getPromotionalBannerTypeSelector()}
                </div>
            </div>
        </React.Fragment>
    );

    getOptionsForCategoryDescription = () => (
        <React.Fragment>
            {this.getSimpleTypeSelector(this.state.categoryOpenedClosed, 'CategoryOpenedClosed', this.onCategoryOpenedClosedChange, 'categoryOpenedClosed')}
        </React.Fragment>
    )

    getOptionsForFilterPanel = () => (
        <React.Fragment>
            {this.getSimpleTypeSelector(this.state.maxfilter, 'ShowFilterQuantity', this.onMaxfilterChange, 'maxfilter')}
            {this.getSimpleTypeSelector(this.state.productListFilters__FilterOption, 'FilterPanelClick', this.onProductListFilters__FilterOption, 'filterOption')}
            <div>
                <p className="options__info">{getTranslation("showFilter")}</p>
                {this.getSimpleTypeSelector(this.state.productListFilters__Manufacturer, 'Filters_Manufacturer', this.onProductListFiltersChange__Manufacturer, 'productListFilters__Manufacturer', "checkbox")}
                {this.getSimpleTypeSelector(this.state.productListFilters__Brand, 'Filters_Brand', this.onProductListFiltersChange__Brand, 'productListFilters__Brand', "checkbox")}
                {this.getSimpleTypeSelector(this.state.productListFilters__Availability, 'Filters_Availability', this.onProductListFiltersChange__Availability, 'productListFilters__Availability', "checkbox")}
                {this.getSimpleTypeSelector(this.state.productListFilters__Rate, 'Filters_Rate', this.onProductListFiltersChange__Rate, 'productListFilters__Rate', "checkbox")}
                {this.getSimpleTypeSelector(this.state.productListFilters__Photos, 'Filters_Photos', this.onProductListFiltersChange__Photos, 'productListFilters__Photos', "checkbox")}
                {this.getSimpleTypeSelector(this.state.productListFilters__Attributes, 'Filters_Attributes', this.onProductListFiltersChange__Attributes, 'productListFilters__Attributes', "checkbox")}
                {this.getSimpleTypeSelector(this.state.productListFilters__Flags, 'Filters_Flags', this.onProductListFiltersChange__Flags, 'productListFilters__Flags', "checkbox")}
            </div>
             
        </React.Fragment>
    )

    getOptionsForProductList = () => (
        <React.Fragment>
            {this.getAmountInput(true)}
            {this.getSimpleTypeSelector(this.state.selectedViewName, 'SelectProductListType', this.onSelectedViewNameChange, 'selectedViewName')}
            {this.getSimpleTypeSelector(this.state.showAttributesOnProductsPage, 'ShowAttributesOnLists', this.onShowAttributesOnProductsPageChange, '')}
            {this.getAttributesOptionsOnViewSelector(this.state.attributesQuantityOnQuickView, 'attributesQuantityOnQuickView', this.state.showAllAttributesOnQuickView, 'showAllAttributesOnQuickView', 'AttributesQuantityOnQuickView')}
            {this.getAttributesOptionsOnViewSelector(this.state.attributesQuantityOnListView, 'attributesQuantityOnListView', this.state.showAllAttributesOnListView, 'showAllAttributesOnListView', 'AttributesQuantityOnListView')}
            {this.getSimpleTypeSelector(this.state.showShortDesc, 'ShowShortDescription', this.onShowShortDescChange, 'showShortDesc')}
            {this.getSimpleTypeSelector(this.state.allowAddingToCartMultiVariantProductsOnProductsList, 'AllowAddingToCartMultiVariantProductsOnProductsList', this.onAllowAddingToCartMultiVariantProductsOnProductsListChange, 'allowAddingToCartMultiVariantProductsOnProductsList')}
        </React.Fragment>
    );

    // getOptionsForProductDetails = (type) => (
    //     <React.Fragment>
    //         {type !== 3 ? this.getSimpleTypeSelector(this.state.productDetailsPresentation, "Pd_ProductDetailsPresentation", this.onProductDetailsPresentationTypeChange, 'productDetailsPresentationType') : ''} 
    //         {this.getSimpleTypeSelector(this.state.productsComparison, "Pd_ProductDetailsProductComparison", this.onProductDetailsProductComparisonTypeChange)}
    //         {this.getSimpleTypeSelector(this.state.afterAddingToCart, "Pd_AfterAddingToCart", this.onProductDetailsAfterAddingToCartChange, 'productDetailsAfterAddingToCartType')}
	// 		{this.getSimpleTypeSelector(this.state.grapicalVariantsPresentation, "Pd_GrapicalVariantsPresentation", this.onGrapicalVariantsPresentationChange, 'productDetailsGrapicalVariantsPresentationType')}
    //     </React.Fragment>
    // )

    getOptionsForCart = () => (
        <React.Fragment>
            {this.getSimpleTypeSelector(this.state.showUnitRateOnCartPage, 'ShowUnitRateOnCartPage', this.onShowUnitRateOnCartPageChange, '')}
            {/* {this.getSimpleTypeSelector(this.state.showPoints, 'ShowPoints', this.onShowPointsChange, 'showPoints', 'checkbox')} */}
        </React.Fragment>
    );

    getOptionsClassNameBottomMenu = () => (
        <div className={optionsClassNameBottomMenu(this)}>
            {/* <div className={optionsBtnClassName(this)}> */}
                <div className="options__buttoncancel">
            <button
                onClick={this.props.closeOptions}
                className="options__cancel"
            >
                {getTranslation("Cancel")}
            </button>
            </div>
    


            {/* <div className={optionsBtnClassName(this)}> */}
            <div className="options__buttonsave">
            <button
                onClick={this.handleSave}
                className="options__save"
            >
                {getTranslation("Save")}
            </button>
            </div>
        </div>
    )

    getOptions = () => {
        switch (this.state.elementType) {
            case "header": return this.getOptionsForHeader();
            case "newsSection": return this.getOptionsForRecommended();
            case "categoryDescription": return this.getOptionsForCategoryDescription();
            case "filterPanel": return this.getOptionsForFilterPanel();
            case "promotionalBanner": return this.getOptionsForPromotionalBanners();
            case "products-list": return this.getOptionsForProductList();
            case "cart": return this.getOptionsForCart();
            // case "product": {
            //     if(this.props.elementInOptions) {
            //         if(this.props.elementInOptions.element.id === 'product-details-3') {
            //             return this.getOptionsForProductDetails(3);
            //         } else {
            //             return this.getOptionsForProductDetails();
            //         }
            //     }
            //     break;
            // } 
            default: return this.getAmountInput();
        }
    }

    render = () => (
        <Modal
            isOpen={this.props.areOptionsOpen}
            onRequestClose={this.props.closeOptions}
            ariaHideApp={false}
            contentLabel="Options"
            className={modalOptionsClassName(this)}
            overlayClassName="overlay"
            shouldCloseOnOverlayClick={false}
            
        >
            <div className={optionsClassName(this)}>
                <div className="options__header">
                    <p className="options__element-name">
                        {getTranslation(typeTranslations[this.state.elementType])}
                    </p>
                    <button className='options__close' onClick={this.props.closeOptions}>
                        <BackIcon/>
                    </button>
                </div>
                {this.getOptions()}
                {this.getOptionsClassNameBottomMenu()}
            </div>
          
        </Modal>
        
    )
}

function optionsClassNameBottomMenu(e) {
    let className;
    if(e.props.elementInOptions) {
        if(e.props.elementInOptions.element.name === 'products') {
            className = 'options__bottom-menu productListOptionsBottomMenu';
        }
        else if(e.props.elementInOptions.element.name === 'filters') {
            className = 'options__bottom-menu filterOptionsBottomMenu';
        }
        else {
            className = 'options__bottom-menu';
        }
    }
    return className;
}

function modalOptionsClassName(e) {
    let className;
    if(e.props.elementInOptions) {
        if(e.props.elementInOptions.element.name === 'products') {
            className = 'productList-modal-options modal-options ';
        }
        else if(e.props.elementInOptions.element.name === 'filters') {
            className = 'filter-modal-options modal-options ';
        }
        else {
            className = 'modal-options';
        }
    }
    return className;
}

function optionsClassName(e) {
    let className;
    if(e.props.elementInOptions) {
        if(e.props.elementInOptions.element.name === 'products') {
            className = 'productListOptions options ';
        } 
        else if(e.props.elementInOptions.element.name === 'filters') {
            className = 'filterOptions options ';
        }
        else {
            className = 'options';
        }
    }
    return className;
}

Options.propTypes = {
    areOptionsOpen: PropTypes.bool.isRequired,
    closeOptions: PropTypes.func.isRequired,
    elementInOptions: PropTypes.object,
    updateChangesOption: PropTypes.func.isRequired,
    pushNotification: PropTypes.func.isRequired,
    changeNameAndConfigForRecommended: PropTypes.func.isRequired,
    changeConfig: PropTypes.func.isRequired,
    updateTemplateSettings: PropTypes.func.isRequired,
};

export default Options;

const BackIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" >
        <path fillRule="evenodd" d="M18.69 5.321a1.057 1.057 0 0 0-1.498 0L12 10.503 6.808 5.31A1.057 1.057 0 1 0 5.31 6.808L10.503 12 5.31 17.192a1.057 1.057 0 1 0 1.497 1.497L12 13.497l5.192 5.192a1.057 1.057 0 1 0 1.497-1.497L13.497 12l5.192-5.192a1.064 1.064 0 0 0 0-1.487z" />
    </svg>
)
